export interface IUnitTbl {
	unitId: number;
	name?: string;
	isActiveStr?: string;
	isActive: boolean;
	fuelTypeId?: number;
	fuelTypeName?: string;
	isUpdatedOffline: boolean;
	canDelete: boolean;
};

export class UnitTbl implements IUnitTbl {
	unitId = 0;
	name = '';
	isActiveStr = '';
	isActive = false;
	fuelTypeId = 0;
	fuelTypeName = '';
	isUpdatedOffline = false;
	canDelete = false;
};
